export default "__VITE_ASSET__d8ac1300__"